export default "__VITE_ASSET__7cbb7366__"